/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_Audio_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Rendering" |
*
* @param {Render_Audio_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_title = /** @type {((inputs?: Render_Audio_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rendu audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio-Rendering")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rendering audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка звука")
	if (locale === "es") return /** @type {LocalizedString} */ ("Representación de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频渲染")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオレンダリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो रेंडरिंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renderização de áudio")
	return /** @type {LocalizedString} */ ("Audio Rendering")
});